import { ThumbnailImageMetadata } from '@app/core/thumbnails/types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { apiClient } from '../../../api';

export interface ThumbnailInfo {
  segmentId: number;
  thumbnailUrl: string;
  metadata: ThumbnailImageMetadata;
}

/**
 * React Query wrapper around api.segments.fetchThumbnails()
 * TODO: use generated client or hook when implementing a library
 * like Kubb.
 */
export function useApiThumbnailsRange(
  stationId: string,
  from: string | number,
  to: string | number,
  options?: Partial<UseQueryOptions<ThumbnailInfo[]>>,
) {
  // if the range is in the future, do not cache data more than 30 seconds
  // otherwise cache for 1 hour
  const staleTime = new Date(to) >= new Date() ? 30 * 1000 : 60 * 60 * 1000;

  return useQuery({
    queryKey: [
      'thumbnails-range',
      {
        stationId,
        from,
        to,
      },
    ],

    queryFn: () => apiClient.segments.fetchThumbnails(stationId, from, to).then((res) => res.data),

    staleTime,
    ...options,
  });
}
